import React from "react";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

function TestimonialCard({ image, name, rating, review }) {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div className="testimonial-card">
      <img src={image} alt={name} className="user-photo" />
      <div className="user-info">
        <h3 className="user-name">{name}</h3>
        {/* <div className="star-rating">{"⭐".repeat(rating)}</div> */}
        <div className="star-rating" style={{ display: "flex", gap: "4px" }}>
          {[...Array(fullStars)].map((_, i) => (
            <FaStar key={`full-${i}`} color="#FFD700" />
          ))}
          {hasHalfStar && <FaStarHalfAlt key="half" color="#FFD700" />}
          {[...Array(emptyStars)].map((_, i) => (
            <FaRegStar key={`empty-${i}`} color="#FFD700" />
          ))}
        </div>
      </div>
      <p className="review-text">"{review}"</p>
    </div>
  );
}

export default TestimonialCard;
